





































import Vue from "vue";
import { Integration } from "@/models/integration";
import { getUser } from "@/utils/getUser";
import IntegrationService from "@/services/integrationService";
import CookieService from "@/services/cookieService";
import {Item} from "@/models/sharedFiles";



export default Vue.extend({
  data() {
    return {
      integrationList: [] as Integration[],
      integrationNumber: 0,
      integrationSummaryFile: [] as Item[],
      isLoaded: false
    };
  },
  async created() {
    this.isLoaded = true
    const jwt = window.localStorage.getItem("jwt");
    if (jwt) {
      const user = getUser();
      const userGroups = user?.groups;
      console.log("userGroups: ", userGroups);
      const integrationService = new IntegrationService(jwt);
      const response = await integrationService.getIntegrations(userGroups);
      const cookieService = new CookieService(jwt);
      await cookieService.getCookie();

      if (response && response.status == 200) {
        if (response.data && response.data["data"]) {
          response.data["data"].forEach(element => {
            this.integrationList.push(element);
          });
          this.integrationNumber = response.data["number"];
          this.integrationSummaryFile = response.data["integrationSummaryFile"];
        }
      }
    }
    this.isLoaded = false;
  }
});
